import pictogramAsset from "assets/img/pictogram/asset.svg"

import { FC } from "react"
import { useTranslation } from "react-i18next"

import { Flex, FlexItem } from "components/Flex"
import Lmid from "components/Lmid/Lmid"
import Text from "components/Text/Text"
import Button from "components/Button/Button"
import LmidModalResultItem from "../LmidModalResultItem"
import ExistingLmidData from "models/ExistingLmidData"
import { Guid } from "@/types"

interface ILmidModalCurrentTenantProps {
    existingLmidData: ExistingLmidData
    /** Replaces the default "edit the existing asset?" message, e.g. when editing is not offered. */
    message?: string
    onEditExistingAssetClick?(assetId: Guid): void
}

const LmidModalCurrentTenant: FC<ILmidModalCurrentTenantProps> = ({
    existingLmidData,
    message,
    onEditExistingAssetClick,
}) => {
    const { t } = useTranslation()

    return (
        <div className="py-4 text-center">
            <Text className="white-space-pre-line mb-1 mx-auto">
                {message ?? t("lmidModal.lmidExistsEditAsset")}
            </Text>
            <LmidModalResultItem
                align="center"
                pictogram={{
                    src: pictogramAsset,
                }}>
                {!!existingLmidData.articleDescription &&
                    <Text>{existingLmidData.articleDescription}</Text>
                }
                {!!existingLmidData.articleNo &&
                    <Text>{t('common.artNo')}: {existingLmidData.articleNo}</Text>
                }
                <Flex>
                    <FlexItem shrink={0}>
                        <Text>{t('common.lmid')}:&nbsp;</Text>
                    </FlexItem>
                    <Lmid lmid={existingLmidData.lmid} labeled={existingLmidData.isLabeled} />
                </Flex>
            </LmidModalResultItem>
            {!!existingLmidData.updateAssetLink && !!existingLmidData.assetId && !!onEditExistingAssetClick &&
                <div className="mt-1">
                    <Button
                        theme="secondary"
                        label={t("common.editAsset")}
                        onClick={() => onEditExistingAssetClick(existingLmidData.assetId!)}
                        data-testid="edit-asset-btn"
                    />
                </div>
            }
        </div>
    )
}

export default LmidModalCurrentTenant
